module.exports = __webpack_public_path__ + "static/media/Celgene-logo-white.a023dae5.png";